import { initAnalytics } from "@pex/analytics/client";
import { initSentry } from "@pex/observability/client";

initSentry(process.env.NEXT_PUBLIC_WEBSITE_SENTRY_DSN ?? "");
initAnalytics({ appName: "website" });
